import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { extend, map as lodashMap, merge } from 'lodash-es';

import { AuthenticationService } from './authentication.service';
import { ClientContextService } from './client-context.service';
import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    dynamicConfigs: any = {};
    constructor(private _http: HttpClient,  private _clientContextService: ClientContextService, private _logger: LoggerService) {}

    private _getHeaders(extraHeaders: object = {}, isPolling: boolean = false): HttpHeaders {
        let headersConfig = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization':`Bearer ${this._clientContextService.getToken()}`,
            'id_token': this._clientContextService.getIdToken()
        };

        headersConfig = Object.assign({}, headersConfig, extraHeaders);

        if (environment.extraHeaders) {
            headersConfig = extend({}, headersConfig, environment.extraHeaders);
        }

        return new HttpHeaders(headersConfig);
    }

    /**
     *
     * @param path
     * @param paramsObj
     * @param extraHeaders
     * @param authenticated
     * @param isPolling
     */
    // get(path: string, paramsObj: any = {},
    //     extraHeaders: object = {}, authenticated: boolean = true, isPolling: boolean = false): Observable<any> {
    //     let params = new HttpParams().set('t', `${(new Date()).getTime()}`);
    //     lodashMap(paramsObj, (value, key) => {
    //         if (value || value === 0) {
    //             params = params.set(key, value);
    //         }
    //     });

    //     const headers: HttpHeaders = this._getHeaders(extraHeaders, isPolling);
    //     return this._http.get(`${this._getApiBaseUrl()}${path}`, {
    //         headers: headers,
    //         params: params
    //     }).pipe(
    //         map(this._extractData.bind(this)),
    //         catchError(this._handleError.bind(this)));
    // }
    get(path: string, isPathAbsolute: boolean = false, paramsObj: any = {},
        extraHeaders: object = {}, authenticated: boolean = true, isPolling: boolean = false,
        t: any = (new Date()).getTime()): Observable<any> {
        let params = new HttpParams().set('t', `${t}`);
        lodashMap(paramsObj, (value, key) => {
            if (value || value === 0) {
                params = params.set(String(key), String(value));
                // changed
            }
        });

        const headers: HttpHeaders = this._getHeaders(extraHeaders, isPolling);
        const finalPath = isPathAbsolute ? path : `${this._getApiBaseUrl()}${path}`;
        return this._http.get(finalPath, {
            headers: headers,
            params: params
        }).pipe(
            map(this._extractData.bind(this)),
            catchError(this._handleError.bind(this)));
    }

    /**
     *
     * @param path
     * @param body
     * @param extraHeaders
     */
    put(path: string, isPathAbsolute: boolean = false, body: object = {}, extraHeaders: object = {}): Observable<any> {
        const finalPath = isPathAbsolute ? path : `${this._getApiBaseUrl()}${path}`;
        return this._http.put(
            finalPath,
            JSON.stringify(body),
            { headers: this._getHeaders(extraHeaders) }
        ).pipe(
            map(this._extractData.bind(this)),
            catchError(this._handleError.bind(this)));
    }
    // put(path: string, body: object = {}, extraHeaders: object = {}): Observable<any> {
    //     return this._http.put(
    //         `${this._getApiBaseUrl()}${path}`,
    //         JSON.stringify(body),
    //         { headers: this._getHeaders(extraHeaders) }
    //     ).pipe(
    //         map(this._extractData.bind(this)),
    //         catchError(this._handleError.bind(this)));
    // }

    /**
     *
     * @param path
     * @param body
     * @param paramsObj
     */
    patch(path: string, body: object = {}, isPathAbsolute: boolean = false, paramsObj: any = {}, extraHeaders: object = {}, isStringified: boolean = false): Observable<any> {
        let params = new HttpParams();
        lodashMap(paramsObj, (value, key) => {
            if (value) {
                params = params.set(String(key), String(value));
                // changed
            }
        });
        const finalPath = isPathAbsolute ? path : `${this._getApiBaseUrl()}${path}`;
        const newBody = isStringified ? body : JSON.stringify(body);
        return this._http.patch(
            finalPath,
            (newBody),
            { headers: this._getHeaders(extraHeaders), params: params }
        ).pipe(
            map(this._extractData.bind(this)),
            catchError(this._handleError.bind(this)));
    }

    /**
     *
     * @param path
     * @param body
     * @param extraHeaders
     */
    post(path: string, body: object = {}, isPathAbsolute: boolean = false, extraHeaders: object = {}, isStringified: boolean = false): Observable<any> {
        const finalPath = isPathAbsolute ? path : `${this._getApiBaseUrl()}${path}`;
        const newBody = isStringified ? body : JSON.stringify(body);
        return this._http.post(
            finalPath,
            (newBody),
            { headers: this._getHeaders(extraHeaders) }
        ).pipe(
            map(this._extractData.bind(this)),
            catchError(this._handleError.bind(this)));
    }

    /**
     *
     * @param path
     * @param extraHeaders
     * @param queryString
     */
    delete(path: string, isPathAbsolute: boolean = false, extraHeaders: object = {}, queryString: string = ''): Observable<any> {
        const finalPath = isPathAbsolute ? path : `${this._getApiBaseUrl()}${path}`;
        return this._http.delete(
            finalPath,
            { headers: this._getHeaders(extraHeaders) }
        ).pipe(
            map(this._extractData.bind(this)),
            catchError(this._handleError.bind(this)));
    }
    // delete(path: string, extraHeaders: object = {}, queryString: string = ''): Observable<any> {
    //     return this._http.delete(
    //         `${this._getApiBaseUrl()}${path}`,
    //         { headers: this._getHeaders(extraHeaders) }
    //     ).pipe(
    //         map(this._extractData.bind(this)),
    //         catchError(this._handleError.bind(this)));
    // }
    /**
     *
     * @param res
     */
    private _extractData(res: HttpResponse<any>): any {
        this._clientContextService.setAuthorizedUser(true);
        const body = res;
        let resp = {};
        if (body) {
            resp = body || body['data'];
        }
        return resp;
    }

    /**
     *
     * @param error
     */
    // private _handleError(error: HttpErrorResponse | any): any {
    //     let errs;
    //     try {
    //         if (error instanceof HttpErrorResponse) {
    //             const errorBody = error || {};
    //             errs = (errorBody['error'] &&
    //                 (errorBody['error']['errors'] || errorBody['error']['importDataErrors'])) || [];
    //             // _.each(errs, (err) => {
    //             //     errMsg += ` ${err}`;
    //             // });
    //             this._logger.log(`Actual error: ${error.status} - ${error.statusText || ''}`);
    //             if (error.status === 401 || error.status === 0) {
    //                 this._clientContextService.setAuthorizedUser(false);
    //             }
    //         } else {
    //             errs = error.message ? error.message : error.toString();
    //         }
    //         this._logger.log('try error', errs);
    //     } catch (parseError) {
    //         this._logger.log('catch error', parseError);
    //     }
    //     return observableThrowError(errs);
    // }
    private _handleError(error: HttpErrorResponse | any): any {
        let errs;
        try {
            if (error instanceof HttpErrorResponse) {
                const errorBody = error || {};
                errs = (errorBody['error'] &&
                    (errorBody['error']['errors'] || errorBody['error']['importDataErrors'])) || errorBody;
                // _.each(errs, (err) => {
                //     errMsg += ` ${err}`;
                // });
                this._logger.log(`Actual error: ${error.status} - ${error.statusText || ''}`);
                if (error.status === 401) {
                     this._clientContextService.setAuthorizedUser(false);
                }
            } else {
                errs = error.message ? error.message : error.toString();
            }
            this._logger.log('try error', errs);
        } catch (parseError) {
            this._logger.log('catch error', parseError);
        }
        return observableThrowError(errs);
    }
    /**
     * get the base API URL
     */
    private _getApiBaseUrl(): string {
        const apiUrl = this.dynamicConfigs && this.dynamicConfigs['apiUrl'];
        console.log(apiUrl);
        return apiUrl;
    }

    getDynamicConfigs(t: any = (new Date()).getTime()): Observable<any> {
        const params = new HttpParams().set('t', `${t}`);
        return this._http.get('/assets/configs/appconfig.json', { params: params }).pipe(
            map((res: any) => res),
            catchError(this._handleError.bind(this)));

    }
    /**
     * get dynamic configurations
     */
    getJson(path: string, t: any = (new Date()).getTime()): Observable<any> {
        const params = new HttpParams().set('t', `${t}`);
        return this._http.get(path, { params: params }).pipe(
            map((res: any) => res),
            catchError(this._handleError.bind(this)));

    }
    putFileInS3Bucket(signedURL, file, fileAsBuffer: any = null, mimeType): Observable<any> {
        const payload = fileAsBuffer || file;
        // const kmsKeyId = this._clientContextService.getAppConfigById('KMSKeyId');
        return this._http.put(signedURL, payload,
            {
                headers: new HttpHeaders({
                    'Content-Type': mimeType,
                    // 'x-amz-server-side-encryption': 'aws:kms',
                    // 'x-amz-server-side-encryption-aws-kms-key-id': kmsKeyId
                })
            }
        ).pipe(map(data => { }),
            catchError(this._handleError.bind(this)));
    }
}

